// extracted by mini-css-extract-plugin
export default {"studio-leaderboard-desc-wrapper":"studio-leaderboard-desc-wrapper_ViiVx"};